import axios from "axios";
import Config from "../config";
import qs from "qs";
import EventBus from "../components/Ui/EventBus";

let lastValidationTime = null;
let cacheDuration = 60 * 60 * 1000; // 1 saat (milisaniye cinsinden)

function isValidationRequired() {
  return !lastValidationTime || Date.now() - lastValidationTime > cacheDuration;
}

function setLastValidationTime() {
  lastValidationTime = Date.now();
}

export default {
  login(data) {
    return axios.post(Config.endpoint + "/auth/login", qs.stringify(data));
  },

  logout() {
    localStorage.removeItem("authToken");
  },

  loginValidate() {
    if (!isValidationRequired()) {
      return Promise.resolve(true);
    }

    axios.defaults.headers.common["Authorization"] = localStorage.authToken;

    return axios.post(Config.endpoint + "/auth/validate").then((resp) => {
      if (resp.data.success === true) {
        localStorage.setItem("userName", resp.data.data.userName);
        localStorage.setItem("userId", resp.data.data.userId);
        localStorage.setItem("telegram_id", resp.data.data.telegram_id);
        localStorage.setItem("theme", resp.data.data.theme);
        localStorage.setItem("dahili", resp.data.data.dahili);
        EventBus.$emit("userName", resp.data.data.userName);

        setLastValidationTime();

        return true;
      }
      return false;
    });
  },
};
